/**
 * הצגת טקסט עם בידוד דו־כיווני — אותה לוגיקה בדיוק כמו בדוח ה־PDF.
 *
 * הרכיב הזה משתמש ב־`splitBidiRuns` מ־@hakshuri/domain, אותה פונקציה
 * ש־`bidiHtml` בתבנית הדוח משתמשת בה. זה מכוון: אם הכיווניות תיקבע
 * בנפרד בממשק ובדוח, הן ייפרדו זו מזו והבאג יחזור רק באחד מהם.
 */

import { shouldKeepTogether, splitBidiRuns } from '@hakshuri/domain';
import type { ReactElement } from 'react';

export function Bdi({ children }: { children: string }): ReactElement {
  const runs = splitBidiRuns(children);
  return (
    <>
      {runs.map((run, index) =>
        run.isolate ? (
          <bdi
            key={index}
            dir={run.dir === 'auto' ? undefined : run.dir}
            style={shouldKeepTogether(run) ? { whiteSpace: 'nowrap' } : undefined}
          >
            {run.text}
          </bdi>
        ) : (
          <span key={index}>{run.text}</span>
        ),
      )}
    </>
  );
}
